import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtrapagesRoutingModule } from './extrapages-routing.module';
import { Basic404Component } from './basic404/basic404.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared';

@NgModule({
  exports: [],
  declarations: [Basic404Component],
  imports: [CommonModule, ExtrapagesRoutingModule, TranslateModule, SharedModule],
})
export class ExtrapagesModule {}
